export enum RequestErrors {
  WrongRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
  ServerIsDown = 500,
}
